import { MessageParameters, MessageResponse, TemplateModel } from "@schemax-whatsapp/shared-models";
import axios from "axios";
import { config } from 'config';
const {metaWhatsAppConfig} = config

export class WhatsAppMetaService{

   async  createTemplate(req:TemplateModel){
    return await axios.post(`https://graph.facebook.com/${metaWhatsAppConfig.VERSION}/${metaWhatsAppConfig.PHONE_NUMBER_ID}/message_templates`,JSON.stringify(req),{
        "headers": {
            'Authorization': `Bearer ${metaWhatsAppConfig.ACCESS_TOKEN}`,
            'Content-Type': 'application/json'
        },
    }).then((res) => {
            return res.data;
        }).catch(err => {console.log(err); return err });
   }

   async getTemplates(){
      return await axios.get(`https://graph.facebook.com/${metaWhatsAppConfig.VERSION}/${metaWhatsAppConfig.PHONE_NUMBER_ID}/message_templates`,{
        "headers": {
            'Authorization': `Bearer ${metaWhatsAppConfig.ACCESS_TOKEN}`,
            'Content-Type': 'application/json'
        },
    }).then((res)=>{
        return res.data;
      }).catch(err => {console.log(err); return err });
   }

   async sendMessageThroughFbApi(message: MessageParameters): Promise<MessageResponse> {
    return await axios.post(`https://graph.facebook.com/${metaWhatsAppConfig.VERSION}/${metaWhatsAppConfig.PHONE_NUMBER_ID_FOR_SEND}/messages`, {
        "messaging_product": "whatsapp",
        "to": message.recepient,
        "type": "template",
        "template": {
            "name": message.template,
            "language": {
                "code": message.languageCode ? message.languageCode : "en_us"
            },
            "components": [
                // {
                //     "type": "header",
                //     "parameters": [{ "type": "text", "text": "Sandhya Aqua" }]
                // },
                {
                    "type": "body",
                    "parameters": message.parameters,

                }
                
            ]
        }
    }, {
        "headers": {
            'Authorization': `Bearer ${metaWhatsAppConfig.ACCESS_TOKEN}`,
            'Content-Type': 'application/json'
        },
    }).then((res) => {
        return new MessageResponse(true,'success');
    }).catch(err => { return new MessageResponse(false,err) });
}

async sendMessageWithHeaderThroughFbApi(message: MessageParameters): Promise<MessageResponse> {
    return await axios.post(`https://graph.facebook.com/${metaWhatsAppConfig.VERSION}/${metaWhatsAppConfig.PHONE_NUMBER_ID_FOR_SEND}/messages`, {
        "messaging_product": "whatsapp",
        "to": message.recepient,
        "type": "template",
        "template": {
            "name": message.template,
            "language": {
                "code": message.languageCode ? message.languageCode : "en_us"
            },
            "components": message.parameters
        }
    }, {
        "headers": {
            'Authorization': `Bearer ${metaWhatsAppConfig.ACCESS_TOKEN}`,
            'Content-Type': 'application/json'
        },
    }).then((res) => {
        return new MessageResponse(true,'success');
    }).catch(err => { return new MessageResponse(false,err) });
}
}